<div class="tabs">
  <p-tabView
    [activeIndex]="activeIndex()"
    (onChange)="tabChange.emit(options()[$event.index].value)">
    @for (option of options(); track option.value) {
      <p-tabPanel
        [header]="option.label"
        (click)="tabChange.emit(option.value)" />
    }
  </p-tabView>

  @if (buttonLabel(); as label) {
    <ui-create-button
      class="tabs__button"
      [label]="label"
      (buttonClicked)="buttonClicked.emit()" />
  }
</div>
